import Vue from "vue";
import Vuex from "vuex";
import $ from "jquery";
import router from "./router";
import { api, jQuery401Callback } from "./api.js";
import { mapState } from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    doctor_id: null,
    queue_patient_details: [],
    queue_completed_pd: [],
    Waiting_list_pd: [],
    checkedItems: [],
    fromList: null,
    toList: null,
    oldIndex: null,
    newIndex: null,
    // selected:[]
    getOrderValue: null,
    token: "",
    clinic_id: "",
    appointment_id: null,
    questionList: {}
  },
  mutations: {
    doctorId(state, payload) {
      state.doctor_id = payload;
    },
    checkAllAppointment(state, payload) {
      // state.checkedItems = []
      // state.queue_patient_details.map(x => {
      //   state.checkedItems.push(x.id)
      // })
      let PtPayloadInShift = payload.info;
      PtPayloadInShift.forEach(function (x) {
        state.checkedItems.push(x.id);
      });
    },
    checkAllWaiting(state) {
      // state.checkedItems = []
      state.Waiting_list_pd.map(x => {
        state.checkedItems.push(x.id);
      });

      state.queue_patient_details.forEach(function (x) {
        // state.checkedItems.push(x.id);

        let xxxx = x.info;
        console.log(xxxx);
        xxxx.forEach(function (x) {
          state.checkedItems.push(x.id);
        });
      });
    },
    checkAllCompleted(state) {
      state.checkedItems = [];
      state.queue_completed_pd.map(x => {
        state.checkedItems.push(x.id);
      });
    },
    toggle(state, payload) {
      state.checkedItems = [];
    },
    toggleCheckedItems(state, payload) {
      if (state.checkedItems.includes(payload)) {
        let indexOfItem = state.checkedItems.findIndex(x => x == payload);
        state.checkedItems.splice(indexOfItem, 1);
        return;
      }
      state.checkedItems.push(payload);
    },
    load_Waiting_list(state, payload) {
      // waitingList Array
      var arr = Array.from(
        Object.keys(payload.Waiting),
        k => payload.Waiting[k]
      );
      state.Waiting_list_pd = arr;
    },
    load_Patient_list(state, payload) {
      // appointments Array - multiple shifts
      // patients inside every shift is contained in info[]
      // var arr = Array.from(Object.keys(payload.Queue), k => payload.Queue);
      // state.queue_patient_details = arr;
      // console.log(arr);
      state.queue_patient_details = payload.Queue;
    },
    queue_completed_list(state, payload) {
      // completed Array
      var arr = Array.from(
        Object.keys(payload.Completed),
        k => payload.Completed[k]
      );
      state.queue_completed_pd = arr;
      console.log(arr);
    },
    update_patient_list(state, payload) {
      // console.log(payload)
      state.queue_patient_details = payload;
    },
    update_completed_list(state, payload) {
      // console.log(payload)
      state.queue_completed_pd = payload;
    },
    update_Waiting_list(state, payload) {
      // console.log(payload)
      state.Waiting_list_pd = payload;
    },
    onEnd(state, evt) {
      state.fromList = evt.from.id;
      state.toList = evt.to.id;
      state.oldIndex = evt.oldIndex;
      state.newIndex = evt.newIndex;
      console.log("fromList" + " " + evt.from.id);
      console.log("toList" + " " + evt.to.id);
      console.log("newindex" + " " + evt.newIndex);
      console.log("oldindex" + " " + evt.oldIndex);
    },
    questionList(state, payload) {
      state.questionList = payload;
    },
    emptyCheckedItems(state) {
      state.checkedItems = [];
    }
  },

  actions: {
    updateQue({ dispatch, commit }, payload) {
      let changed_appointments = {
        changed_appointments: {
          q_id: payload.qid,
          state: payload.state,
          order: payload.order
        }
      };
      console.log(changed_appointments);
      let token = localStorage.getItem("token", this.token);
      $.ajax({
        url: api + "/v2/appointments_switch",
        method: "POST",
        headers: {
          token: token
        },
        contentType: "application/json",
        data: JSON.stringify(changed_appointments),
        error: jQuery401Callback,
        success: res => {
          // console.error(res.message)
          if (res.status == true) {
            dispatch("getdata");
          }
        }
      });
    },
    updateQueues(context, payload) {
      console.log(payload);
    },
    getdata(context, clinic_id) {
      console.log("getdatalocalStorage.clinic_id", localStorage.clinic_id)
      let token = localStorage.getItem("token");
      // let clinic_id = localStorage.clinic_id;
      $.ajax({
        url: api + `/appointment_new?clinic_id=${clinic_id}`,
        method: "GET",
        headers: {
          token: token
        },
        success: res => {
          var arr_result = res;
          console.log(arr_result);
          context.commit("load_Patient_list", arr_result);
          context.commit("queue_completed_list", arr_result);
          context.commit("load_Waiting_list", arr_result);
        },
        error: jQuery401Callback
      });
    },
    delete(context, payload) {
      let token = localStorage.getItem("token", this.token);
      let dataToSend = {
        id: context.state.checkedItems
      };

      $.ajax({
        url: api + "/v2/appointments",
        method: "PUT",
        headers: {
          token: token
        },
        contentType: "application/json",
        data: JSON.stringify(dataToSend),
        success: res => {
          // context.commit('toggle')
          // window.location.reload()
          context.commit("emptyCheckedItems");
          context.dispatch("getdata");
          context.commit("update_Waiting_list", payload.checkWaitingList);
          context.commit("update_completed_list", payload.checkCompletedList);
          context.commit("update_patient_list", payload.checkAppointmentList);
        },
        error: jQuery401Callback
      });
    },

    changeAppointmentPosition(context, payload) {
      console.warn(payload);
      let qid;
      let order;
      let state;
      context.commit("onEnd", payload);
      let toState = context.state.toList;
      let fromState = context.state.fromList;
      let newIndex = context.state.newIndex;
      let oldIndex = context.state.oldIndex;

      // from shift-0 to shift-1
      if (fromState == "shift-0" && toState == "shift-1") {
        // store = queue_patient_details
      }
      // from shift-1 to
      // from waiting to
      // from completed to

      if (fromState == "2" && toState == "1") {
        qid = context.state.Waiting_list_pd[newIndex].id;
        state = 1;
        let newIndexValue = newIndex + 1;
        if (newIndexValue < context.state.Waiting_list_pd.length) {
          order = context.state.Waiting_list_pd[newIndex + 1].order;
        } else if (newIndexValue == context.state.Waiting_list_pd.length) {
          order = context.state.Waiting_list_pd[newIndex - 1].order;
        } else {
        }
      } else if (fromState == "3" && toState == "1") {
        qid = context.state.Waiting_list_pd[newIndex].id;
        state = 1;
        let newIndexValue = newIndex + 1;
        // alert(context.state.Waiting_list_pd.length)
        // alert(newIndexValue)
        if (newIndexValue < context.state.Waiting_list_pd.length) {
          // alert("1")
          order = context.state.Waiting_list_pd[newIndex + 1].order;
          // alert(order)
        } else if (newIndexValue == context.state.Waiting_list_pd.length) {
          // alert("2")
          order = context.state.Waiting_list_pd[newIndex - 1].order;
          // alert(order)
        } else {
        }
      } else if (fromState == "1" && toState == "2") {
        qid = context.state.queue_completed_pd[newIndex].id;
        state = 2;
        let newIndexValue = newIndex + 1;
        if (newIndexValue < context.state.queue_completed_pd.length) {
          order = context.state.queue_completed_pd[newIndex + 1].order;
        } else if (newIndexValue == context.state.queue_completed_pd.length) {
          order = context.state.queue_completed_pd[newIndex - 1].order;
        } else {
        }
      } else if (fromState == "1" && toState == "1") {
        qid = context.state.Waiting_list_pd[newIndex].id;
        state = null;
        if (oldIndex > newIndex) {
          order = context.state.Waiting_list_pd[newIndex + 1].order;
        } else if (oldIndex < newIndex) {
          order = context.state.Waiting_list_pd[newIndex - 1].order;
        } else {
        }
      } else if (fromState == "2" && toState == "2") {
        qid = context.state.queue_completed_pd[newIndex].id;
        state = null;
        if (oldIndex > newIndex) {
          order = context.state.queue_completed_pd[newIndex + 1].order;
        } else if (oldIndex < newIndex) {
          order = context.state.queue_completed_pd[newIndex - 1].order;
        } else {
        }
      }

      let changed_appointments = {
        changed_appointments: {
          q_id: qid,
          state: state,
          order: order
        }
      };

      console.log(changed_appointments);
      let token = localStorage.getItem("token", this.token);
      // $.ajax({
      //   url: api + '/v2/appointments_switch',
      //   method: 'POST',
      //   headers: {
      //     "token": token
      //   },
      //   contentType: "application/json",
      //   data: JSON.stringify(changed_appointments),
      //   success: (res) => {
      //     console.log(res.message)
      //     if (res.status == true) {
      //     }
      //   }
      //
      // })
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js